<template>
  <div tabindex="0" class="extendplayer-container" @keydown.esc="escEvent">
    <div class="extendplayer-dim" :class="isAiChannel ? 'filter' : ''"></div>
    <img class="extendplayer-bgimg" :src="getChannelImg" alt="hotchannel-dummy.jpeg" />
    <div class="extendplayer-info-header">
      <div class="extend-iconwrap" @click="closeMiniPlayer">
        <img src="/media/images/icon/close-fullscreen-icon.png" alt="close-fullscreen-icon.png" />
      </div>
      <h1 class="channel-name">{{ getChannelName }}</h1>
      <div class="extend-favoritewrap" v-if="isShowBookmark">
        <font-awesome-icon v-if="isBookmarkYn" :icon="['fas', 'star']" class="star" @click="onClickBookmark" />
        <font-awesome-icon v-else :icon="['far', 'star']" class="star" @click="onClickBookmark" />
      </div>
    </div>

    <!-- 앨범 이미지(AI Channel의 경우)-->
    <div class="extendplayer-info-contents" v-if="isAiChannel">
      <img class="album-img" :src="getChannelImg" alt="albumimg" />
    </div>

    <div class="extendplayer-info-footer">
      <!-- 노래제목, 아티스트-->
      <ul class="musicinfo-wrap">
        <li class="musicinfo-musicname" v-html="getMusicInfo.musicNm"></li>
        <li class="musicinfo-artist">
          {{ getMusicInfo.artist }}
        </li>
      </ul>
      <!-- Live -->
      <div class="livestreaming-wrap">
        <div class="livedot-wrap">
          <span class="reddot"></span>
          <span class="livestreaming-text">LIVE</span>
        </div>
        <!-- 애니메이션 구현 필요-->
        <!-- <div class="live-animationbar"></div> -->
        <div class="live-animation-wrap">
          <vue-skeleton-loader
            class="skeltone-bar"
            type="rect"
            :rounded="true"
            radius="12"
            :height="2"
            animation="wave"
          />
        </div>
        <!-- Skelton -->
      </div>
      <!-- 이전,재생/중지,다음-->
      <ul class="musiccontrol-wrap">
        <li class="prev-icon" @click="onClickPrevNext('prev')">
          <img src="/media/images/icon/prev-white-icon.png" alt="prev-white-icon.png" />
        </li>
        <li class="playpause-icon-wrap cursor" @click="onClickControlMusic">
          <font-awesome-icon v-if="getIsPlay" class="extend-pause-icon" :icon="['fas', 'stop']" />
          <font-awesome-icon v-else-if="!getIsPlay" class="extend-play-icon" :icon="['fas', 'play']" />
          <!-- <img src="/media/images/icon/pause-white-icon.png" alt="pause-white-icon.png" /> -->
        </li>
        <li class="next-icon" @click="onClickPrevNext('next')">
          <img src="/media/images/icon/next-white-icon.png" alt="next-white-icon.png" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  emits: ['close-miniplayer', 'click-bookmark'],
  methods: {
    closeMiniPlayer() {
      this.$gatag.event('web_player_page_close_button'); // 플레이어 닫기 버튼
      this.$emit('close-miniplayer');
    },
    escEvent() {
      this.$gatag.event('web_player_page_close_button'); // 플레이어 닫기 버튼
      this.$emit('close-miniplayer');
    },
    onClickControlMusic() {
      this.$store.dispatch('controlMusic');
    },
    onClickBookmark() {
      const { recomId } = this.$store.getters['player/getMyChannelInfo'];
      this.$gatag.event('web_player_page_favorite_button'); // 즐겨찾기
      this.$emit('click-bookmark', {
        spaceId: this.$cookies.get('spaceId'),
        recomId,
        isBookmarkYn: this.isBookmarkYn
      });
    },
    async onClickPrevNext(dir = 'prev') {
      await this.$store.dispatch('player/prevNextChanel', {
        direction: dir
      });
    }
  },
  mounted() {
    document.querySelector('.extendplayer-container').focus();
  },
  computed: {
    isShowBookmark() {
      if (this.$store.getters['player/getMyChannelInfo']) {
        const { channelType } = this.$store.getters['player/getMyChannelInfo'];

        return channelType === 'T';
      }
      return false;
    },
    isBookmarkYn() {
      if (this.$store.getters['player/getMyChannelInfo']) {
        const { bookmarkYn } = this.$store.getters['player/getMyChannelInfo'];

        return bookmarkYn === 'Y';
      }

      return false;
    },
    getChannelImg() {
      return this.$store.getters['player/getChannelImage'];
    },
    getChannelName() {
      return this.$store.getters['player/getChannelName'];
    },
    getMusicInfo() {
      return this.$store.getters.gettersChannelMusicInfoObject;
    },
    getIsPlay() {
      return this.$store.getters.gettersIsPlay;
    },
    isAiChannel() {
      if (this.$store.getters['player/getMyChannelInfo']) {
        const { channelType } = this.$store.getters['player/getMyChannelInfo'];

        return channelType === 'G';
      }
      return false;
    }
  }
};
</script>
<style scoped src="@/assets/css/extendplayer/extendplayer.css"></style>
